
import { Component, Input } from '@angular/core';

@Component({
  selector: 'my-tabautopass',
  styles: [
    `

  .pane {
    border-color: rgba(0, 0, 0, 0.08);
    color: #656565;
    background-color: #ffffff;
    margin:5px;
  }
  .nav-tabs {
    border-bottom: 5px solid #a6b7bf;
  }
  
  `
  ],
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content class="pane"></ng-content>
      <ng-container *ngIf="template" class="pane"
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ filter: dataContext }"
      >
      </ng-container>
    </div>
  `
  
})
export class TabComponentAutopass {
  @Input('tabTitle') title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() dataContext;
}
